// extracted by mini-css-extract-plugin
export default {"heading":"Uj-z","list":"Vj-z"};